import React, { useEffect, useState } from 'react';
import Overview from './components/Aboutus/Overview';
import BusinessEnquiry from "./components/Forms/Enquiry";
import axios from 'axios';
import { API_BASE_URL } from "./Utils/useApi";
import { CircularProgress } from "@mui/material";
import { useParams, useNavigate } from 'react-router-dom';
import './components/Aboutus/index.css';
import BreadCrumbs from './components/BreadCrumb/Index';

// Import relevant icons
import { FaBox, FaRupeeSign, FaPalette, FaTruck, FaLeaf } from 'react-icons/fa';

// Static data for quality section with icons
const quality = {
  heading: "Why Partner With Us",
  points: [
    {
      title: "End-to-end fulfilment with assured quality",
      Icon: FaBox
    },
    {
      title: "Competitive pricing with volume flexibility",
      Icon: FaRupeeSign
    },
    {
      title: "Custom branding and packaging support",
      Icon: FaPalette
    },
    {
      title: "On-time delivery and inventory backup",
      Icon: FaTruck
    },
    {
      title: "Sustainable alternatives across categories",
      Icon: FaLeaf
    }
  ]
};

const Servicedetails = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!slug) {
          navigate('/our-services');
          return;
        }

        const response = await axios.get(
          `${API_BASE_URL}/what_we_do_details.php?slug=${slug}`
        );

        if (!response.data || !response.data.homeBanners || !response.data.overview) {
          navigate('/our-services');
          return;
        }

        setPageData(response.data);
      } catch (err) {
        setError(err.message);
        console.error("Error fetching service details:", err);
        navigate('/what-we-do');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug, navigate]);

  if (loading) {
    return (
      <div className="preloader flex-center">
        <CircularProgress size={24} />
      </div>
    );
  }

  if (error) {
    return (
      <div>Error: An error occurred while fetching data</div>
    );
  }

  const { overview, serviceContent } = pageData;

  return (
    <main>
      <BreadCrumbs />
      {overview && <Overview Data={overview} serviceDetail={true} serviceContent={serviceContent} _class={'text-lg-center text-start'} />}

      {/* Static quality list */}
      <div className="col-12 float-start Vision py-lg-5 py-2">
        <div className="col-lg-10 col-12 m-auto text-center">
          {/* Section heading */}
          <h2 className="mb-4">{quality.heading}</h2>

          <ul
            data-aos="fade-up"
            data-aos-offset="100"
            data-aos-duration="500"
            data-aos-once="true"
            data-aos-easing="ease-in-sine"
            className="d-lg-flex justify-content-center list-unstyled p-0"
          >
            {quality.points.map(({ title, Icon }, idx) => (
              <li
                key={`quality-point-${idx}`}
                className="d-flex flex-column align-items-center text-center mx-3 mb-4 mb-lg-0"
              >
                <span
                  className="spanIcon mb-3 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: '72px', height: '72px', padding: '16px', background: 'conic-gradient(from 0deg, #033f73, #0e5584, #033f73)' }}
                >
                  <Icon size={32} className="text-white" />
                </span>
                <span className="mt-2">{title}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <BusinessEnquiry />
    </main>
  );
};

export default Servicedetails;
